// import React, { useEffect, useState } from 'react'
// import Editor, { Toolbar } from 'react-simple-wysiwyg'

// const MedsDetailsRecords = ({
//   patientDiagnosis,
//   patientDBdata,
//   diagnosisName,
//   setPatientDBdata,
//   noteID,
// }) => {
//   const [tempHtml, setTempHtml] = useState('')

//   useEffect(() => {
//     if (!diagnosisName) return

//     const medsFreetype =
//       patientDBdata?.currentNote?.data?.freeTypesEverything?.plans?.[diagnosisName]?.MedsDetails || ''

//     const medsDetailsArray =
//       patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.medsDetails || []

//     const generatedHtml =
//       Array.isArray(medsDetailsArray) && medsDetailsArray.length > 0
//         ? `
//           <div>
//             ${medsDetailsArray
//               .map((med) =>
//                 med?.editedMed ? `<div>${med.editedMed}</div>` : ''
//               )
//               .join('')}
//           </div>
//         `
//         : ''

//     setTempHtml(medsFreetype || generatedHtml)
//   }, [patientDBdata, diagnosisName])

//   const handleBlur = () => {
//     if (!tempHtml?.trim()) return

//     setPatientDBdata((prev) => ({
//       ...prev,
//       currentNote: {
//         ...prev.currentNote,
//         data: {
//           ...prev.currentNote?.data,
//           freeTypesEverything: {
//             ...(prev.currentNote?.data?.freeTypesEverything || {}),
//             plans: {
//               ...(prev.currentNote?.data?.freeTypesEverything?.plans || {}),
//               [diagnosisName]: {
//                 ...(prev.currentNote?.data?.freeTypesEverything?.plans?.[diagnosisName] || {}),
//                 MedsDetails: tempHtml,
//               },
//             },
//           },
//         },
//       },
//       allNotes: prev?.allNotes?.map((note) => {
//         if (note?.id === noteID) {
//           const parsedData = note?.data ? JSON.parse(note.data) : {}
//           return {
//             ...note,
//             data: JSON.stringify({
//               ...parsedData,
//               freeTypesEverything: {
//                 ...(parsedData?.freeTypesEverything || {}),
//                 plans: {
//                   ...(parsedData?.freeTypesEverything?.plans || {}),
//                   [diagnosisName]: {
//                     ...(parsedData?.freeTypesEverything?.plans?.[diagnosisName] || {}),
//                     MedsDetails: tempHtml,
//                   },
//                 },
//               },
//             }),
//           }
//         }
//         return note
//       }),
//     }))
//   }


//   return (
//     <div className="w-100 my-4">
//       {/* <div style={{ width: '30%' }}>Med Details</div> */}

//       <Editor
//         value={tempHtml}
//         onChange={(e) => setTempHtml(e.target.value)}
//         onBlur={handleBlur}
//         containerProps={{
//           style: {
//             width: '100%',
//             background: '#2D2D2D',
//             color: 'white',
//             border: 0,
//           },
//         }}
//       >
//         <Toolbar hidden />
//       </Editor>
//     </div>
//   )
// }

// export default MedsDetailsRecords

import React, { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const MedsDetailsRecords = ({
  patientDiagnosis,
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
  hasMedsDetails, setHasMedsDetails
}) => {
  const [tempHtml, setTempHtml] = useState('')
  // const [hasMedsDetails, setHasMedsDetails] = useState(false)

  const medsDetailsArray =
    patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.medsDetails

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything?.plans
      ?.[diagnosisName]?.MedsDetails

  // ⛔ No meds → render nothing
  if (!diagnosisName || !Array.isArray(medsDetailsArray) || !medsDetailsArray.length) {
    return null
  }

  useEffect(() => {
    const validMeds = medsDetailsArray
      .map(med => med?.editedMed?.trim())
      .filter(Boolean)

    if (!validMeds.length) {
      setHasMedsDetails(false)
      return
    }

    const generatedHtml = `
      <div>
        ${validMeds.map(med => `<div>${med}</div>`).join('')}
      </div>
    `

    setTempHtml(savedFreeType || generatedHtml)
    setHasMedsDetails(true)

    // ✅ Save generated HTML if not already saved
    if (!savedFreeType) {
      setPatientDBdata(prev => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...(prev.currentNote.data?.freeTypesEverything || {}),
              plans: {
                ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
                [diagnosisName]: {
                  ...(prev.currentNote.data?.freeTypesEverything?.plans?.[diagnosisName] || {}),
                  MedsDetails: generatedHtml,
                },
              },
            },
          },
        },
      }))
    }
  }, [diagnosisName, medsDetailsArray])

  const handleBlur = () => {
    if (!tempHtml.trim()) return

    setPatientDBdata(prev => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...(prev.currentNote.data?.freeTypesEverything || {}),
            plans: {
              ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
              [diagnosisName]: {
                ...(prev.currentNote.data?.freeTypesEverything?.plans?.[diagnosisName] || {}),
                MedsDetails: tempHtml,
              },
            },
          },
        },
      },
      allNotes: prev.allNotes?.map(note => {
        if (note.id !== noteID) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...(parsedData.freeTypesEverything || {}),
              plans: {
                ...(parsedData.freeTypesEverything?.plans || {}),
                [diagnosisName]: {
                  ...(parsedData.freeTypesEverything?.plans?.[diagnosisName] || {}),
                  MedsDetails: tempHtml,
                },
              },
            },
          }),
        }
      }),
    }))
  }

  if (!hasMedsDetails) return null

  return (
    <div className="w-100 my-4">
      <Editor
        value={tempHtml}
        onChange={e => setTempHtml(e.target.value)}
        onBlur={handleBlur}
        containerProps={{
          style: {
            width: '100%',
            background: '#2D2D2D',
            color: 'white',
            border: 0,
          },
        }}
      >
        <Toolbar hidden />
      </Editor>
    </div>
  )
}

export default MedsDetailsRecords
